import React from 'react';
import './flotantes.css';

function Flotantes() {

    return (            
        <div className="flotante">
            <a href="https://wa.me/573152206211" target="_blank" rel="noreferrer">
                <i className="fab fa-whatsapp"></i>
            </a>
        </div>
    );
}

export default Flotantes;